import {TypeImpl} from './TypeImpl';
import {Type} from './Type';

export class TypeSearch extends TypeImpl implements Type {

    public execute(): void {
        if (document.documentElement.clientWidth > 640) {
            return;
        }
        this.target.setAttribute('inputmode', 'search');
    }

}
